module.exports = __webpack_public_path__ + "media/images/ohap_ui_my_courses_outline_on-d66bfc7f1cefc60993f9cef6c2d63664.png";